import get from "lodash/get";
import uniq from "lodash/uniq";
import partition from "lodash/partition";

import localStorage from "shared/util/localStorage";

const _SEEN_NOTIFICATIONS_KEY = "seen_notifications_key";

/**
 * Write to local cache of seen notifications.
 * @param {[string]} seenNotifications - an array of notification ids.
 */
export function setSeenNotifications(seenNotifications = []) {
	localStorage.setItem(_SEEN_NOTIFICATIONS_KEY, uniq(seenNotifications));
}

/**
 * Get local cache of seen notifications.
 * @return {[string]} - an array of notification ids.
 */
export function getSeenNotifications() {
	const storedData = localStorage.getItem(_SEEN_NOTIFICATIONS_KEY);

	return (storedData ? storedData.split(",").reverse() : []).slice(0, 50);
}

/**
 * Generate a mostly-unique, deterministic identifier from a Notification entity.
 * @param {Object} notification - a Notification entity.
 * @return {string} - a notification identifier.
 */
export function generateNotificationId(notification) {
	return `${notification.type}_${(get(notification, "target.user.id") || (notification.title + notification.subtitle))}`;
}

/**
 * Split Notification entities into Boost/non-Boost.
 * @param {[Object]} notifications - a list of Notification entities.
 * @return {[[Object]]} - an array of arrays of Notification entities.
 */
export function separateBoostNotifications(notifications) {
	// Split notifications into Boost/non-Boost.
	const [
		boostActivity,
		nonBoostActivity,
	] = partition(notifications, ({ isViaSpotlight }) => isViaSpotlight);

	// Reverse so they're in the proper order.
	return [
		boostActivity.reverse(),
		nonBoostActivity.reverse(),
	];
}



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/util/helpers.js